import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Switch } from "@mui/material";
import { Link } from "react-router-dom";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import SwalMessage from "../_Components/SwalMessage";
import { IconHall } from "../../../assets/icons";

function DataGridAgentCommission({
  data,
  setSelectedCommissionId,
  setShowCreateCommissionGroupModal,
}) {
  const changeStatusAgentCommission = async (id) => {
    try {
      const response = await ApiAgentCommission.changeStatusAgentCommission({ id: id });
      if (response.succeeded) {
        document.getElementById("submitButton").click();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
      SwalMessage({ title: "خطا در تغییر وضعیت", iSsuccess: false });
    }
  };
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "supplierCompanyName",
        Header: "تامین کننده",
        minWidth: "100px",
      },
      {
        accessor: "name",
        Header: "نام گروه کمیسیون",
        minWidth: "100px",
      },
      {
        accessor: "strCommissionType",
        Header: "نوع کمیسیون",
        minWidth: "100px",
      },
      {
        Header: "پیش فرض",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.isDefault}
              value="row.original.isDefault"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        ),
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.isActive ? true : false}
              value="row.original.isActive"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              onChange={() => changeStatusAgentCommission(row.original.id)}
            />
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 90,
        maxWidth: 90,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            {/* {!row.original.isDefault && (
              <Button
                className="btn btn-light-primary btn-sm mr-2 btn-icon"
                onClick={() => {
                  setSelectedCommissionId(row.original.id);
                  setShowCreateCommissionGroupModal(true);
                }}
                title="تغییر نام گروه کمیسیون"
              >
                <i className="far fa-edit text-small"></i>
              </Button>
            )} */}

            {row.original.commissionType == 1 ?
              <>
                <Link
                  className="btn btn-light-info btn-sm mr-2 btn-icon"
                  title="ویرایش کمیسیون صندلی های رویداد"
                  to={`/supplierCommissionEvent/${row.original.id}`}
                >
                  <IconHall />
                </Link>
                <Link
                  className={`btn btn-light-primary btn-sm mr-2 btn-icon `}
                  to={`/supplierCommissionEvent/${row.original.id}?ourDefault=true`}
                  title="ویرایش کمیسیون پیش فرض تفریحان در صندلی های رویداد"
                >
                  <IconHall />
                </Link>
              </>
              : <>
                <Link
                  className="btn btn-light-info btn-sm mr-2 btn-icon"
                  to={`/editAgentCommissionItems/${row.original.id}`}
                  title="ویرایش آیتم های گروه کمیسیون"
                >
                  <i className="fa fa-list text-small"></i>
                </Link>
                <Link
                  className={`btn btn-light-primary btn-sm mr-2 btn-icon ${!row.original.isDefault && "invisible"}`}
                  to={`/editAgentCommissionItems/${row.original.id}?ourDefault=true`}
                  title="ویرایش آیتم های گروه کمیسیون پیش فرض تفریحان"
                >
                  <i className="fa fa-list text-small"></i>
                </Link>
              </>
            }
          </div>
        ),
      },
    ],
    []
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAgentCommission;
